import { Button } from '@design-system';
import { FC } from 'react';

import { Franchises } from '../../../types/Franchises';
import { getWordCount } from '../../../utils/journals/franchises';
import { readingTimeCalculator } from '../../../utils/readingTimeCalculator';
import { JournalsTile } from '../JournalsTile';

interface JournalsListProps {
  button?: {
    handleClick: () => void;
    href: string;
    title: string;
  };
  handleArticleClick: (story: Franchises, index: number) => void;
  max?: number;
  stories: Franchises[];
  title: string;
}

export const JournalsList: FC<JournalsListProps> = ({
  button,
  handleArticleClick,
  max = 4,
  stories,
  title,
}) => {
  if (stories.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex w-full items-center gap-3">
        <h3 className="w-full flex-1 text-md text-neutral-4 md:text-lg">
          {title}
        </h3>
        {button && (
          <div className="shrink-0">
            <Button
              as="a"
              href={button.href}
              label={button.title}
              onClick={button.handleClick}
              size="sm"
              variant="tertiary"
            />
          </div>
        )}
      </div>

      <div className="grid-section gap-y-6">
        {stories.slice(0, max).map((story, index) => (
          <div
            key={story.uuid}
            className="col-span-12 w-full sm:col-span-6 md:col-span-3"
          >
            <JournalsTile
              description={story.content.subtitle}
              href={`/${story.full_slug}`}
              image={story.content.poster}
              imageRatio={story.content.posterRatio}
              mediaDuration={story.content.mediaDuration}
              onClick={() => {
                handleArticleClick(story, index);
              }}
              publishedAt={story.content.date}
              readingTime={readingTimeCalculator(
                getWordCount(story.content.article),
              )}
              tag={story.content.tag}
              title={story.content.title}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
